import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router';
import jwt from 'jwt-decode';

import UsersList from './Users/UsersList';
import UserProfile from './Users/UserProfile';
import AddUserForm from './Users/AddUserForm';

import { callGET, callPOST, callPUT, callGETASYNC } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import { validateFilesWithinSizeLimit, reportFileSizeValidationError } from '../../Utils/FileUploadValidation';
import { currencyListUtil } from '../../Utils/CommonFunctions';
import BreadCrumbs from "../../Components/UI/BreadCrumbs";
import Modal from "react-bootstrap/Modal";
// import ContainerFluid from "../../hoc/ContainerFluid";
import * as actions from '../../store/actions'
import Wrp from "../../hoc/Wrp/Wrp";
import {setUserInfoSession,getLoggedInUserId} from '../../Utils/UserFunctions';
import Buttons from '../../Components/UI/Buttons';
import { LinkContainer } from 'react-router-bootstrap';

class UsersContiner extends Component {
  _isMounted = false;
  state ={
    usersList : [],
    userDetail : null,
    error : [],    
    totalUsers : 0,
    selectedUser : null,
    profileLoader : false,
    adduserFormFields:{
        // userObject : null,
        userId : {
          value : null
        },
        isActive : {
          value : true,
        },
        isOrg : {
          value : true,
        },
        isSystemUser : {
          value : true,
        },
        userType : {
          value : this.props.userType,
        },
        profile_avatar : {
          value : null
        },
        is_api_user:{
          value:false,
        },
        api_key:{
          value:''
        },
        is_guest_user:{
          value:false,
        },
        guest_user_key:{
          value:''
        },
        guest_key_last_used_at:{
          value:''
        },
        firstName : {
          field : "text",
          required : true,
          title : 'First Name',
          placeHolder : "",
          value : '',
          classname : 'form-control input-full mandatory',
          error: '',
          options : []
        },
        lastName : {
          field : "text",
          required : true,
          title : 'Last Name',
          placeHolder : "",
          value : '',
          classname : 'form-control input-full mandatory',
          error: '',
          options : []
        },
        password : {
          title : "Password",
          field : "password",
          required : true,
          placeHolder : "",
          passwordShow : true,
          disabled : false,
          error: '',
          classname : 'form-control input-full pr-4',
          value : '',
          isError:false
        },
        username : {
          title : "Username",
          field : "text",
          required : false,
          placeHolder : "",
          disabled : false,
          error: '',
          classname : 'form-control input-full',
          value : ''
        },
        email : {
          field : "text",
          required : true,
          disabled : false,
          title : 'Email',
          placeHolder : "",
          value : '',
          error: '',
          classname : 'form-control input-full mandatory',
          options : []
        },
        timeZone : {
          title : "Time Zone",
          field : "select2",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        language : {
          title : "Language",
          field : "select2",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        locale : {
          title : "Locale",
          field : "select2",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        dateformat : {
          title : "Dateformat",
          field : "select2",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        preferredCurrency : {
          title : "Preferred Currency",
          field : "select2",
          required : true,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        role : {
          title : "Role",
          field : "select2",
          required : true,
          placeHolder : "",
          classname : 'form-control input-full mandatory',
          value : '',
          error: '',
          options : [],
          isError:false
        },
        profile : {
          title : "Profile",
          field : "select2",
          required : true,
          disabled : false,
          placeHolder : "",
          classname : 'form-control input-full mandatory',
          value : '',
          error: '',
          options : [],
          isError:false
        },
        description : {
          title : "Description",
          field : "textarea",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : [],
          maxlength:250
        },
        work_number : {
          title : "Work Number",
          field : "text",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        },
        mobile_number : {
          title : "Mobile Number",
          field : "text",
          required : false,
          placeHolder : "",
          classname : 'form-control input-full',
          value : '',
          error: '',
          options : []
        }
    },
    addUserPasswordRules : {
      lowercase : false, //one lowercase character
      numeric : false, //one number
      uppercase : false, //one uppercase character
      minChar : false, //8 characters minimum
      specialChar : false, //one special character
    },
    guestKeyUpdated: false,
  }

  // static getDerivedStateFromProps(props, state) {
  //   return state;
  // }

  componentDidMount() {
    this._isMounted = true;
    // const {userType} = this.props;
    
    if(this.props.show === "users") {

    }else if(this.props.show === "adduser" || this.props.show === "edituser") {
      

       // if(this.props.show === "edituser") {
            callGET("utils/userutil-data")
            .then(response => {
              const responseData = response.data.data;
              // console.log('responseData',responseData);
              const timezoneList = [];
              const languageList = [];
              const localeList = [];
              const dateFormatList = [];

              let timezoneId = '';
              let languageId = '';
              let localeId = '';
              let dateFormatId = '';

              if(responseData) {
                if(responseData.timezone_list.length > 0) {
                  responseData.timezone_list.map((arr,i) => {
                    const value = {
                      "value": arr.timezone_id,
                      "label": arr.timezone_name,
                    }
                      timezoneList.push(value);
                      return true; 
                    })
                  timezoneId = responseData.timezone_list[0].timezone_id;
                }
                if(responseData.languages_list.length > 0) {
                  responseData.languages_list.map((arr,i) => {
                    const value = {
                      "value": arr.language_code,
                      "label": arr.language_name,
                    }
                    languageList.push(value);
                    return true; 
                  })
                  languageId = responseData.languages_list[0].language_code;
                }
                if(responseData.locales_list.length > 0) {
                  responseData.locales_list.map((arr,i) => {
                    const value = {
                      "value": arr.locale_code,
                      "label": arr.locale_name,
                    }
                    localeList.push(value);
                    return true; 
                  })
                  localeId = responseData.locales_list[0].locale_code;
                }
                if(responseData.date_format_list.length > 0) {
                  responseData.date_format_list.map((arr,i) => {
                    const value = {
                      "value": arr.date_formatcode,
                      "label": arr.date_format,
                    }
                    dateFormatList.push(value);
                    return true;
                  })
                  dateFormatId = responseData.date_format_list[0].date_formatcode;
                }

                const updateState = {...this.state};
                updateState.adduserFormFields.timeZone.options=timezoneList;
                // updateState.adduserFormFields.timeZone.value=timezoneId;

                updateState.adduserFormFields.language.options=languageList;
                // updateState.adduserFormFields.language.value=languageId;

                updateState.adduserFormFields.locale.options=localeList;
                // updateState.adduserFormFields.locale.value=localeId;

                updateState.adduserFormFields.dateformat.options=dateFormatList;
                // updateState.adduserFormFields.dateformat.value=dateFormatId;
                
                // Load currency options
                const currencyList = currencyListUtil();
                const currencyOptions = [];
                if(currencyList && currencyList.length > 0) {
                  currencyList.map((arr) => {
                    const value = {
                      "value": arr.key || arr.value,
                      "label": arr.key || arr.value,
                    }
                    currencyOptions.push(value);
                    return true;
                  });
                }
                updateState.adduserFormFields.preferredCurrency.options = currencyOptions;
                
                if(this.props.show === "adduser") {
                  /*updateState.adduserFormFields.timeZone.value=timezoneId;
                  updateState.adduserFormFields.language.value=languageId;
                  updateState.adduserFormFields.locale.value=localeId;
                  updateState.adduserFormFields.dateformat.value=dateFormatId;*/
                  updateState.adduserFormFields.timeZone.value=responseData.organziation_default_time_zone;
                  updateState.adduserFormFields.language.value=responseData.organziation_default_language;
                  updateState.adduserFormFields.locale.value=responseData.organziation_default_locale;
                  updateState.adduserFormFields.dateformat.value=responseData.organziation_default_date_format;
                  // Set default currency to organization default currency if available
                  if(responseData.organziation_default_currency) {
                    updateState.adduserFormFields.preferredCurrency.value = responseData.organziation_default_currency;
                  }
                }
                this.setState(updateState);
              }

            })
            .catch(err => {
              console.log("Connction Error============",err);
            });
          if(this.props.show === "edituser") {
            const userId = this.props.match.params.id;
            callGET("users/"+userId)
              .then(response => {
                const responseData = response.data.data;
                const updateState = { ...this.state };
                // updateState.adduserFormFields.userObject = responseData;
                updateState.adduserFormFields.userId.value = responseData.id;
                updateState.adduserFormFields.firstName.value = responseData.first_name;
                updateState.adduserFormFields.lastName.value = responseData.last_name;
                updateState.adduserFormFields.email.value = responseData.email;
                updateState.adduserFormFields.profile.value = responseData.profile_id;
                updateState.adduserFormFields.role.value = responseData.role_id;
                updateState.adduserFormFields.password.disabled = true;
                updateState.adduserFormFields.email.disabled = true;
                updateState.adduserFormFields.username.disabled = true;
                updateState.adduserFormFields.username.value = responseData.username;
                updateState.adduserFormFields.password.value = '';
                updateState.adduserFormFields.is_api_user.value = responseData.is_api_user;
                updateState.adduserFormFields.api_key.value = responseData.api_key;
                updateState.adduserFormFields.is_guest_user.value = responseData.is_guest_user;
                updateState.adduserFormFields.guest_key_last_used_at.value = responseData.guest_key_last_used_at || '';
                updateState.adduserFormFields.guest_user_key.value = responseData.guest_user_key ? '********************************' : '';
                updateState.adduserFormFields.profile_avatar.value = responseData.profile_avatar ? responseData.profile_avatar : null;
                //if(responseData.profile_name === 'Account Administrator')
                if(responseData.is_organization_admin === true || responseData.is_organization_admin === 'true')
                  updateState.adduserFormFields.profile.disabled = true;
                updateState.adduserFormFields.description.value = responseData.description;

                updateState.adduserFormFields.timeZone.value = responseData.timezone_id;
                updateState.adduserFormFields.language.value = responseData.language;
                updateState.adduserFormFields.locale.value = responseData.country_locale;
                updateState.adduserFormFields.dateformat.value = responseData.date_pattern;
                updateState.adduserFormFields.preferredCurrency.value = responseData.preferred_currency || '';
                updateState.adduserFormFields.work_number.value = responseData.work_number;
                updateState.adduserFormFields.mobile_number.value = responseData.mobile_number;
                updateState.adduserFormFields.userType.value = (responseData.is_external===true)?'EXTERNAL':'INTERNAL'
                updateState.adduserFormFields.isActive.value = responseData.is_active;
                updateState.adduserFormFields.isOrg.value = responseData.is_organization_admin;
                updateState.adduserFormFields.isSystemUser.value = responseData.is_system_user;
                updateState.guestKeyUpdated = false;
                // updateState.adduserFormFields.username.value = responseData.username;
                this.setState(updateState);
                this.getProifleAndRolesList(updateState.adduserFormFields);
              })
              .catch(err => {
                  console.log("Connction Error============",err);
              });
        }else{
          this.getProifleAndRolesList(this.state.adduserFormFields);
        }
    }
  }
  generateNewTokenAPI = ()=>{
    
    callPOST("users/generate-token")
        .then(response => {
        if(response.status===200){
          const resData = response.data;
          if(resData.code===200) {
            // console.log('resData',resData);
            const updateState = { ...this.state };
            updateState.adduserFormFields.api_key.value = resData.data;
            this.setState(updateState);
          
            }
          }
          
        })
        .catch(err => {
            console.log("Connction Error============",err);
        });
    }

  generateGuestUserKey = () => {
    const generatedKey = `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`.slice(0, 64);
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.adduserFormFields.guest_user_key.value = generatedKey;
      updateState.guestKeyUpdated = true;
      return updateState;
    });
  }
  getProifleAndRolesList = (adduserFormFields)=>{
    let userTypeBool = false;
    if(adduserFormFields.userType.value==='EXTERNAL'){
      userTypeBool = true;
    }
    callGET("profiles/view/"+userTypeBool+"?orderBy=profile_name&direction=ASC&page=0&size=10000")
        .then(response => {
        if(response.status===200){
          const resData = response.data;
          if(resData.code===200) {
          const responseData = resData.data.content;
          const profileList = [];
          let profileId = '';
          if(responseData) {
            if(responseData.length > 0) {
              responseData.map((arr,i) => {
                const value = {
                "label": arr.profile_name,
                "value": arr.id,
              }
                profileList.push(value) 
              })
              profileId = responseData[0].id;
            }
          }
          const updateState = { ...this.state };
          updateState.adduserFormFields.profile.options = profileList;
          if(this.props.show !== "edituser"){
            updateState.adduserFormFields.profile.value = profileId;
          }
          this.setState(updateState);
            }
          }
          
        })
        .catch(err => {
            console.log("Connction Error============",err);
        });

        callGET("roles/list/"+userTypeBool+"?orderBy=role_name&direction=ASC&page=0&size=10000")
        .then(response => {
          const updateState = { ...this.state };
          const rolesList = [];
          if(response.status===200){
            const resData = response.data;
            if(resData.code===200){
              const responseContent = resData.data.content;
              let roleId = '';
              if(responseContent) {
                if(responseContent.length > 0) {
                  responseContent.map((arr,i) => {
                    const value = {
                    "label": arr.role_name,
                    "value": arr.id,
                  }
                    rolesList.push(value) 
                  })
                  roleId = responseContent[0].id;
                  
                  if(this.props.show !== "edituser"){
                    updateState.adduserFormFields.role.value = roleId;
                  }
                }
              }
            }
          }
          console.log("rolesList",rolesList);
          updateState.adduserFormFields.role.options = rolesList;
          this.setState(updateState);  
        
        })
        .catch(err => {
            console.log("Connction Error============",err);
        });
  }
  componentDidUpdate(previousProps, previousState) {
    if (previousState.usersList!== this.state.usersList) {
    }
  }

  addUserOnChangeHandler = (event) => {
    const updateState = { ...this.state };

    // Validation for password..    
    const updateStatePasswordRule = updateState.addUserPasswordRules;
    // console.log('event.target.name',event.target.name);
    if(event.target.name === 'password') {
      const passwordValue = event.target.value;

      console.log("-----------------Password Rules-------------------");
      console.log('one_lowercase',/[a-z]/.test(passwordValue));
      console.log('one_number',/\d/.test(passwordValue));
      console.log('one_uppercase',/[A-Z]/.test(passwordValue));
      console.log('one_sepcialcharacter',/^[a-zA-Z0-9 ]*$/.test(passwordValue))
      console.log("-------------------------------------------------");

      updateStatePasswordRule.lowercase = /[a-z]/.test(passwordValue) ? true : false;
      updateStatePasswordRule.numeric = /\d/.test(passwordValue) ? true : false;
      updateStatePasswordRule.uppercase = /[A-Z]/.test(passwordValue) ? true : false;
      updateStatePasswordRule.minChar = passwordValue.length >= 8 ? true : false;
      updateStatePasswordRule.specialChar = /^[a-zA-Z0-9 ]*$/.test(passwordValue) ? false : true;
      if(updateStatePasswordRule.lowercase && updateStatePasswordRule.numeric && updateStatePasswordRule.uppercase && updateStatePasswordRule.minChar &&  updateStatePasswordRule.specialChar ){
        updateState.adduserFormFields['password'].isError= false;
      }
      this.setState(updateState);
    }
    
    if(event.target.name === 'is_api_user' && event.target.value===true && updateState.adduserFormFields.api_key.value===''){
      this.generateNewTokenAPI();
    }
    if(event.target.name === 'is_guest_user' && event.target.value===false){
      updateState.adduserFormFields.guest_user_key.value = '';
      updateState.guestKeyUpdated = false;
    }
    if(event.target.name === 'is_guest_user' && event.target.value===true){
      const currentGuestKey = updateState.adduserFormFields.guest_user_key.value;
      if(currentGuestKey === ''){
        const generatedKey = `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`.slice(0, 64);
        updateState.adduserFormFields.guest_user_key.value = generatedKey;
        updateState.guestKeyUpdated = true;
      }
    }
    // endss

    updateState.adduserFormFields[event.target.name].value= event.target.value;
    updateState.adduserFormFields[event.target.name].error='';
    console.log('updateState.adduserFormFields',updateState.adduserFormFields);
    this.setState(updateState);
  }

  getGuestUserKeyForPayload = () => {
    if (!this.state.adduserFormFields.is_guest_user.value) {
      return '';
    }
    const guestKey = this.state.adduserFormFields.guest_user_key.value;
    const isMaskedKey = typeof guestKey === 'string' && /^\*+$/.test(guestKey);
    if (isMaskedKey) {
      return null;
    }
    return (guestKey && guestKey.trim().length > 0) ? guestKey.trim() : null;
  }

  select2OnChangeHandler = (value, name) => {
    const updateState = { ...this.state };
    updateState.adduserFormFields[name].value= value;
    this.setState(updateState);
  }

  toggleProfileLoader = () => {
    const updateState = { ...this.state };
    updateState.profileLoader = !updateState.profileLoader;
    this.setState(updateState);
  }

  viewUserDetail = (userId) => {
    this.toggleProfileLoader();
    callGET("users/"+userId)
      .then(response => {
        this.toggleProfileLoader();
        const updateState = { ...this.state };
        updateState.userDetail = response.data.data;
        updateState.selectedUser=userId;
        this.setState(updateState);
      })
      .catch(err => {
        this.toggleProfileLoader();
        console.log("Connction Error============",err);
      });
  }
  validate = (updateState) => {
    let isValid = true;
    const updateStatePasswordRule = updateState.addUserPasswordRules;
    const adduserFormFields = updateState.adduserFormFields;
    let violations = [];
    if(updateStatePasswordRule && updateStatePasswordRule.lowercase === false || updateStatePasswordRule.minChar === false || 
      updateStatePasswordRule.numeric === false || updateStatePasswordRule.specialChar === false || updateStatePasswordRule.uppercase === false) {
        updateState.adduserFormFields['password'].isError = true;
        updateState.adduserFormFields['password'].error ="Please Enter a Valid Password";
        isValid = false;
    }else{
      updateState.adduserFormFields['password'].isError = false;
      updateState.adduserFormFields['password'].error ="";
    }
    if(adduserFormFields.profile.options.length===0 && adduserFormFields.role.options.length===0) {
      violations.push("Please create profile and role For External User");
      updateState.adduserFormFields['profile'].isError = true;
      updateState.adduserFormFields['role'].isError = true;
    }
    if(adduserFormFields.profile.options.length===0 && adduserFormFields.role.options.length!==0) {
      violations.push("Please create Profile For External User");
      updateState.adduserFormFields['profile'].isError = true;
    }
    if(adduserFormFields.role.options.length===0 && adduserFormFields.profile.options.length!==0) {
      violations.push("Please create Role For External User");
      updateState.adduserFormFields['role'].isError = true;
    }
    Object.entries(adduserFormFields).map((item, index) => {
      if(item[1]?.required && item[1].required===true &&  item[1].value===""){
        updateState.adduserFormFields[item[0]].isError = true;
        isValid = false;
        updateState.adduserFormFields[item[0]].error = item[1].title +" is required";

      }
    })
    this.setState(updateState);
    return {
      violations: violations,
      isValid: isValid
    }
  }
  saveUserHandler = () => {
    const updateState = { ...this.state };
    const header = {
        'Content-Type': 'application/json'
      }
    const {addFromDVpage,toogleCloseUserPopupAndLoad} = this.props;
    let userTypeBool = false;
    if(this.state.adduserFormFields.userType.value==='EXTERNAL'){
      userTypeBool = true;
    } 
    let validationResponse = this.validate(updateState);
    if(validationResponse.violations.length>0) {
      let violation = '';
      validationResponse.violations.map((message)=>{
        violation += message + '<br/>';
      });
      this.props.failMessage(violation);
      return false;
    }else if (!validationResponse.isValid){
      return false;
    }
    // Validation for password..    
    // const updateStatePasswordRule = updateState.addUserPasswordRules;
    // console.log(updateStatePasswordRule);
    // if(updateStatePasswordRule && updateStatePasswordRule.lowercase === true && updateStatePasswordRule.minChar === true && 
    //   updateStatePasswordRule.numeric === true && updateStatePasswordRule.specialChar === true && updateStatePasswordRule.uppercase === true) {

    // }else {
    //   const updateState = {...this.state};
    //   updateState.adduserFormFields['password'].isError = true;
    //   this.setState(updateState);
    //   return false;
    // }
    /*if(this.state.adduserFormFields.password.value === '') {
      this.props.failMessage('Password must not be empty'); 
      return false;
    }*/
    // endss

    this.props.Loader();

    const body = {
      "first_name":this.state.adduserFormFields.firstName.value,
      "last_name":this.state.adduserFormFields.lastName.value,
      "email":this.state.adduserFormFields.email.value,
      "password":this.state.adduserFormFields.password.value,
      "description": this.state.adduserFormFields.description.value,
      "role_id": this.state.adduserFormFields.role.value,
      //"profile_id":this.state.adduserFormFields.profile.value
      "profile_id": this.state.adduserFormFields.profile.value,
      "timezone_id": this.state.adduserFormFields.timeZone.value,
      "language": this.state.adduserFormFields.language.value,
      "country_locale": this.state.adduserFormFields.locale.value,
      "date_pattern": this.state.adduserFormFields.dateformat.value,
      "preferred_currency": this.state.adduserFormFields.preferredCurrency.value,
      "work_number": this.state.adduserFormFields.work_number.value,
      "mobile_number": this.state.adduserFormFields.mobile_number.value,
      "is_api_user":this.state.adduserFormFields.is_api_user.value,
      "api_key":this.state.adduserFormFields.api_key.value,
      "is_guest_user":this.state.adduserFormFields.is_guest_user.value,
      "guest_user_key":this.getGuestUserKeyForPayload(),
      "profile_avatar": this.state.adduserFormFields.profile_avatar.value,
      "is_active": true,
      "active": true,
      is_external:userTypeBool
    }
    callPOST("users/create",body,header)
    .then(response => {
      
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        this.props.succMessage(responseData.message);
        if(addFromDVpage===false){
          this.props.history.push("/users");
        }else{
          toogleCloseUserPopupAndLoad();
        }
      }else if(responseData.code === ShipConstants.API_STATUS_FAIL) {
        if(responseData.violations.length > 0) {
          responseData.violations.map(arr => {
            if(arr.field_name === 'profileId') {
              updateState.adduserFormFields['profile'].error= arr.message;
            }else if(arr.field_name === 'roleId') {
              updateState.adduserFormFields['role'].error= arr.message;
            }else if(updateState.adduserFormFields[arr.field_name]){
              updateState.adduserFormFields[arr.field_name].error= arr.message;
            }
            
          })
        }else {
          if(responseData.message === 'This username is taken. Try another.') {
            updateState.adduserFormFields['email'].error= responseData.message;
          }else {
            this.props.failMessage(responseData.message);  
          }
        }
        // this.props.failMessage(responseData.message);
      }else {
        this.props.failMessage(responseData.message);
      }
      this.setState(updateState);
      this.props.Loader();
    })
    .catch(err => {
      this.props.Loader();
      this.props.failMessage('Error occured.');
      console.log(err);
    })
  }

  updateUserHandler = () => {
    this.props.Loader();
    const updateState = { ...this.state };
    const header = {
      'Content-Type': 'application/json'
    }
    const userId = this.props.match.params.id;
    const body = {
              "active": this.state.adduserFormFields.isActive.value ,
              // "deleted": false,
              // "accountAdmin": false,
              // "systemUser": false,
              "id": userId,
              // "created_at": "2020-06-17T22:00:11",
              // "updated_at": "2020-06-17T22:00:11",
              // "created_by": "system@gmail.com",
              // "updated_by": "system@gmail.com",
              "first_name": this.state.adduserFormFields.firstName.value,
              "last_name": this.state.adduserFormFields.lastName.value,
              "phone_number": null,
              "email": this.state.adduserFormFields.email.value,
              "username": this.state.adduserFormFields.username.value,
              "password": this.state.adduserFormFields.password.value,
              "description":this.state.adduserFormFields.description.value,
              "timezone_id": this.state.adduserFormFields.timeZone.value,
              "language": this.state.adduserFormFields.language.value,
              "country_locale": this.state.adduserFormFields.locale.value,
              "date_pattern": this.state.adduserFormFields.dateformat.value,
              "preferred_currency": this.state.adduserFormFields.preferredCurrency.value,
              "time_format": "24",
              "is_active": this.state.adduserFormFields.isActive.value ,
              "is_system_user": false,
              "is_account_admin": false,
              "is_deleted": false,
              "is_api_user":this.state.adduserFormFields.is_api_user.value,
              "api_key":this.state.adduserFormFields.api_key.value,
              "is_guest_user":this.state.adduserFormFields.is_guest_user.value,
              "guest_user_key":this.getGuestUserKeyForPayload(),
              "role_id": this.state.adduserFormFields.role.value,
              "profile_id": this.state.adduserFormFields.profile.value,
              "work_number": this.state.adduserFormFields.work_number.value,
              "mobile_number": this.state.adduserFormFields.mobile_number.value,
              "profile_avatar": this.state.adduserFormFields.profile_avatar.value
            } 
    callPUT("users/update",body,header)
    .then(response => {
      this.props.Loader();
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        this.props.succMessage('User updated sucessfully...');
        if(userId === getLoggedInUserId()) {
          setUserInfoSession(responseData);  
        }
        if(this.state.adduserFormFields.isActive.value){
          this.props.history.push("/users");
        }else{
          this.props.history.push("/inactive-users");
        }
        
      }else if(responseData.code === ShipConstants.API_STATUS_FAIL) {
        if(responseData.violations.length > 0) {
          responseData.violations.map(arr => {
            updateState.adduserFormFields[arr.field_name].error= arr.message;
            // updateState.error.push(arr.fieldName+" : "+arr.message)
          })
        }else{
          this.props.warningMessage(responseData.message);
        }
      }else if(responseData.code === ShipConstants.API_STATUS_NOT_FOUNT) {
        this.props.failMessage(responseData.message);
      }else {
        this.props.failMessage(responseData.message);
      }
      this.setState(updateState);
      
    });
  }

  toggleUserStatus = (event, userId) => {
    const updateState = { ...this.state };
    updateState.adduserFormFields.isActive.value = !this.state.adduserFormFields.isActive.value;
    this.setState(updateState);
    /*let state = 'deactivate';
    if(event.target.checked) {
      state = 'activate';
    }
    let isProcess = window.confirm("Are you sure you want to "+state+" the user?");
    if(isProcess) {
      const updateState = { ...this.state };
      callGET("users/update-status/"+userId)
        .then(response => {
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            this.props.succMessage(responseData.message);
            updateState.adduserFormFields.isActive.value = !this.state.adduserFormFields.isActive.value;
            this.setState(updateState);
          }else {
            this.props.failMessage(responseData.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.props.failMessage(err);
          updateState.adduserFormFields.isActive.value = this.state.adduserFormFields.isActive.value;
          this.setState(updateState);
        });
    }*/
  }

  passwordViewHandler = (formName, field) => {
		const updateState = { ...this.state };
		if(formName === "adduser") {
			updateState.adduserFormFields[field].passwordShow = !this.state.adduserFormFields[field].passwordShow;
		}
		this.setState(updateState);
	}
  
  revokePassword = (formName, field) => {
    const updateState = { ...this.state };
    updateState.adduserFormFields[field].value = '';
    updateState.adduserFormFields[field].disabled = !this.state.adduserFormFields[field].disabled;
    updateState.addUserPasswordRules = {
      lowercase : false,
      numeric : false,
      uppercase : false,
      minChar : false,
      specialChar : false,
    };
    this.setState(updateState);
  }

  uploadImageFiles = (e)=> {
      const sizeValidation = validateFilesWithinSizeLimit(e.target.files);
      if (!sizeValidation.valid) {
        reportFileSizeValidationError(sizeValidation.errorMsg, {
          failMessage: this.props.failMessage,
        });
        return;
      }
      this.props.Loader(true);
      const files = e.target.files;
      Object.entries(files).map(([key, fileItem]) => {
        const formData = new FormData();            
        formData.append("upload_file", fileItem);
        const APIURL = 'files/upload';
        callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
        .then(res => {    
            this.props.Loader(false);
            if(res.status==200){                        
                const response = res.data;
              if(response.code===200){
                  const responseData =  response.data;     
                  const userId = this.props.match.params.id;
                  if(userId) {
                    this.updateUploadedImage(responseData);  
                  }else {
                    const updateState = { ...this.state };
                    updateState.adduserFormFields.profile_avatar.value = responseData;
                    this.setState(updateState);
                  }   
                }else{
                  this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
                }                                                
            }else{
                // this.props.Loader(false);
                this.props.failMessage('Something went wrong..');
            }
        })
        .catch(err => {
            this.props.Loader(false);
            this.props.failMessage('Something went wrong..');                    
        })
    })
    }
    removeAvatarImage = ()=>{
      let cfrm = window.confirm("Are you sure want to remove avatar ?");
      if(cfrm===true){
        this.updateUploadedImage(null);
      }
    }

    updateUploadedImage = (uploadedFileId)=>{
      const updateState = { ...this.state };
      updateState.adduserFormFields.profile_avatar.value = uploadedFileId;
      this.setState(updateState); 
    }

    updateUploadedImage1 = (uploadedFileId)=>{
      const userId = this.props.match.params.id;
      let APIURL = 'users/'+userId+'/update-avatar/'+uploadedFileId;
      this.props.Loader(true);
      callPUT(APIURL,{})
      .then(response => {                
          this.props.Loader(false);
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
              this.props.succMessage(responseData.message);   
              const updateState = { ...this.state };
              updateState.adduserFormFields.profile_avatar.value = uploadedFileId;
              this.setState(updateState);    
          }else if(responseData.code===400){
              let validationmsg = [];
              responseData.violations.map((item)=>{
                  validationmsg.push(item.message);
              });
              this.props.failMessage(validationmsg.join(','));
          }else {                    
              this.props.failMessage(responseData.message);
          }
      })
      .catch(err => {
          this.props.Loader(false);
          this.props.failMessage("Something Went Wrong");
          console.log(err);
      })
    }

  render() {
      let breadCrumbs = '';
      if(this.props.show === "adduser" || this.props.show === "edituser") {
        breadCrumbs = {
              backHistory : [{
                href : "/settings",
                name:"Settings"
              },{
                href : "/users",
                name:"Users"
              }],
              pageTitle:this.props.show === "edituser" ? "Edit User" : "Add User",
              buttonList:[
                  {
                    href:"/users",
                    name:"Cancel",
                    attributes:{
                      className:"btn secondary_bg mr-1"
                    },
                    type:"cancel"
                  },
                  {
                    name:"Save",
                    clickHandler: this.props.show === "edituser" ? this.updateUserHandler : this.saveUserHandler,
                    attributes:{
                      className:"btn primary_bg"
                    },
                    type:"save"
                  }
              ]
            }
        }else {
            breadCrumbs = {
            backHistory : [{
              href : "/settings",
              name:"Settings"
            }],
            pageTitle:"Users",
            buttonList:[
                {
                  href:"/adduser",
                  name:"Add New",
                  attributes:{
                  className:"btn primary_bg"
                },
                  type:"addNew",
                  iconClass:"fas fa-plus smoky_light_color",
                }
            ]
          }
        }
        const {addFromDVpage} = this.props;
    return (
      <>
      {this.props.show === "adduser" || this.props.show === "edituser" ? <></>:
         <ul className="nav nav-pills navcrm-primary nav-pills-no-bd fixed-2" role="tablist">
         <LinkContainer to="users">
           <li className="nav-item"> <a className={this.props.show === 'users' ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#userList" role="tab" aria-selected="true">Users List</a> 
           </li>
         </LinkContainer>
         <LinkContainer to="inactive-users">
           <li className="nav-item"> <a className={this.props.show === 'inactiveUsers' ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#inactiveList" role="tab" aria-selected="false">Inactive User</a> 
           </li> 
         </LinkContainer>                 
       </ul>
      }
        <ViewPortStaticHOC 
          Modal={Modal} 
          {...this.props} 
          BreadCrumbs={BreadCrumbs} 
          breadCrumbs={breadCrumbs} 
          isModelOpen={this.props.isQuickAddModalOpen}
          saveUserHandler={this.saveUserHandler}>
          { 
          this.props.show === "adduser" || this.props.show === "edituser" ? 
              <AddUserForm 
                formData={JSON.stringify(this.state.adduserFormFields)} 
                addFromDVpage={addFromDVpage} 
                passwordViewHandler={this.passwordViewHandler} 
                generateNewTokenAPI={this.generateNewTokenAPI}
                changed={this.addUserOnChangeHandler} 
                viewUserDetailClick={this.viewUserDetail} 
                validationError={this.state.error} 
                show={this.props.show} 
                select2Changed={this.select2OnChangeHandler} 
                toggleUserStatus={this.toggleUserStatus} 
                onFileChange={this.onFileChange} 
                uploadImageFiles={this.uploadImageFiles}
                removeAvatarImage={this.removeAvatarImage}
                generateGuestUserKey={this.generateGuestUserKey}
                passwordRule={this.state.addUserPasswordRules}
                revokePassword={this.revokePassword} />
           :
            <UsersList 
               formData={JSON.stringify(this.state.userListFormFields)} 
               usersList={this.state.usersList} 
               viewUserDetailClick={this.viewUserDetail} 
               usersTotalCount={this.state.totalUsers} 
               show={this.props.show} 
               currentUser={this.state.selectedUser}/>
              
          } 
          </ViewPortStaticHOC>  
          </> 
      
    )
  }
  
}
//HOC for normal window and popup(from DV screen)
const ViewPortStaticHOC = (props)=>{
  const {addFromDVpage,saveUserHandler,toogleCloseUserPopup,isModelOpen} = props;
  if(addFromDVpage===true){
   const buttonList = [
     {
       name:"Cancel",
       attributes:{
         className:"btn secondary_bg mr-1"
       },
       type:"cancel",
       clickHandler:toogleCloseUserPopup
     },
     {
       name:"Save",
       clickHandler:saveUserHandler,
       attributes:{
         className:"btn primary_bg"
       },
       type:"save"
     }
  ]
 return(
    <Modal show={isModelOpen} size="xl" >
      <Modal.Header>{'Add User'}</Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      <Modal.Footer><Buttons buttonList={buttonList} /></Modal.Footer>
    </Modal>
 ) 
}else{
  const {BreadCrumbs,breadCrumbs} = props
   return(
    <>
    <BreadCrumbs breadCrumbsList={breadCrumbs}/>
     <div className="viewport">
        <div className="view  view-xl" style={{overflow:"inherit"}}>
          <div className="outerPort" style={{overflow:"auto" }}>
             {props.children}
          </div>
        </div>
     </div>  
     </>
   )
 }
 
}
UsersContiner.defaultProps = {
  addFromDVpage: false,
  userType:'INTERNAL'
}

const mapStateToProps = state => {
  return {
    authenticated: state
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg)),
    warningMessage : (msg) => dispatch(actions.warningMessage(msg))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(UsersContiner)));